import React from "react";
import styled from "styled-components";
import Blog1 from "../../assets/images/blog/1.jpg";
import Blog2 from "../../assets/images/blog/2.jpg";
import { IoMdPerson } from "react-icons/io";
import { CiCalendarDate } from "react-icons/ci";
import { FaAngleRight } from "react-icons/fa";

const BlogSection = () => {
  return (
    <SectionWrapper>
      <Container>
        <Header>
          <h2> Market Insights </h2>
          <p> Stay updated with our latest articles and news. </p>
        </Header>
        <BlogGrid>
          <BlogCard>
            <ImageWrapper>
              <img src={Blog1} alt="Blog 1" />
            </ImageWrapper>
            <Content>
              <h3> Understanding Web Design </h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore...</p>
              <AuthorAndDate>
                <IoMdPerson /> <span> Embark Property </span> <CiCalendarDate />
                <span> Oct 23, 2001 </span>
              </AuthorAndDate>
              <Button>
                Continue Reading <FaAngleRight />
              </Button>
            </Content>
          </BlogCard>
          <BlogCard>
            <ImageWrapper>
              <img src={Blog2} alt="Blog 2" />
            </ImageWrapper>
            <Content>
              <h3> Responsive Design Best Practices </h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore...</p>
              <AuthorAndDate>
                <IoMdPerson /> <span> Embark Property </span> <CiCalendarDate />
                <span> Oct 23, 2001 </span>
              </AuthorAndDate>
              <Button>
                Continue Reading <FaAngleRight />
              </Button>
            </Content>
          </BlogCard>
          <BlogCard>
            <ImageWrapper>
              <img src={Blog2} alt="Blog 3" />
            </ImageWrapper>
            <Content>
              <h3> UI / UX Trends to Watch </h3>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore...</p>
              <AuthorAndDate>
                <IoMdPerson /> <span> Embark Property </span> <CiCalendarDate />
                <span> Oct 23, 2001 </span>
              </AuthorAndDate>
              <Button>
                Continue Reading <FaAngleRight />
              </Button>
            </Content>
          </BlogCard>
        </BlogGrid>
      </Container>
    </SectionWrapper>
  );
};

export default BlogSection;

// Styled Components

const SectionWrapper = styled.section`
  padding: 60px 20px;
  background-color: #f4f4f4;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 40px;

  h2 {
    font-size: 2.5rem;
    margin-bottom: 10px;
    font-family: "Paris Avenue";
  }

  p {
    font-size: 1rem;
    color: #666;
  }
`;

const BlogGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
`;

const BlogCard = styled.div`
  background: white;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-10px);
  }
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 200px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Content = styled.div`
  padding: 20px;

  h3 {
    font-size: 1.25rem;
    margin-bottom: 10px;
  }

  p {
    font-size: 1rem;
    color: #555;
  }
`;

const AuthorAndDate = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
  font-size: 0.875rem;
  color: #888;

  i {
    color: #071d17;
  }

  span {
    margin-left: 5px;
    color: #555;
  }
`;

const Button = styled.button`
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background-color: rgb(167, 140, 76);
  color: #fff;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: background-color 0.3s ease;

  svg {
    font-size: 1.2rem;
  }
`;
